
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/ai-for-government",
      function () {
        return require("private-next-pages/industries/ai-for-government.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/ai-for-government"])
      });
    }
  